import { useState, useEffect } from 'react';

export default function useMousePosition() {
  const [mousePos, setMousePos] = useState({});
  const [isTouch, setIsTouch] = useState(false)

  const handleMouseMove = (event) => {   
    if(isTouch){
      setMousePos({ x: event.clientX, y: 0 });
    } else {
      setMousePos({ x: event.clientX, y: event.clientY });
    }      
    
  };

  const handleTouch = (event) => {    
    setIsTouch(true)          
  }

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('touchstart', handleTouch);    
    
    return () => {
      window.removeEventListener('mousemove',handleMouseMove);
      window.removeEventListener('touchstart', handleTouch);      
    };
  }, [isTouch]);

  return mousePos;
}